import { z } from 'zod';
/** L'autocomplete n'affiche pas plus de villes : une sixième ne sortirait jamais. */
export const COUNTRY_SUGGESTIONS_MAX = 5;
/** Liste complète et ordonnée des villes proposées pour un pays. */
export const setCountrySuggestionsSchema = z.object({
    iataCityCodes: z.array(z.string().min(1)).max(COUNTRY_SUGGESTIONS_MAX),
});
